module.exports = __webpack_public_path__ + "img/certificate-IE-7.5.78eb9a34.jpg";